<template>
  <div class="zj-search-result-table">
    <div class="zj-dropdown-fields">
      <ComponentDropdown
        syscode="EmergencyService"
        ukey="CommunicationResourcesType"
        placeholder="通信资源类别"
        v-on:onSelectChange="onCommunicationResourcesTypeSelectChange"
      ></ComponentDropdown>
    </div>
    <el-table :data="tableData" @row-click="rowclick" :show-header="false">
      <el-table-column>
        <template slot-scope="scope">
          <ComponentInfoPanel
            type="Communicationresources"
            v-bind:info="convert(scope.$index,scope.row)"
          ></ComponentInfoPanel>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import MyApis from "../../../../apis";
import ComponentDropdown from "./Component-Dropdown";
import ComponentInfoPanel from "./Component-InfoPanel";

export default {
  components: {
    ComponentDropdown: ComponentDropdown,
    ComponentInfoPanel: ComponentInfoPanel
  },
  props: {
    targetUri: Object,
    center: {
      type: Object,
      default: function() {
        return [0, 0];
      }
    },
    searchText: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      CommunicationResourcesType: "",
      selectData: null
    };
  },
  mounted: function() {
    this.search();
  },
  methods: {
    convert(index, row) {
      var result = {
        index: row.OrderNum,
        id: row.ResourcesId,
        name: row.ResourceName,
        contact: row.Contact,
        phone: row.Phone,
        longitude: row.Longitude,
        latitude: row.Latitude,
        distance: row.Distance,
        address: row.Address,
        childcount: 0
      };
      return result;
    },
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    search() {
      let searchInfo = {
        ResourceName: this.searchText,
        Longitude: this.center[0] || 0,
        Latitude: this.center[1] || 0,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        CommunicationResourcesType: this.CommunicationResourcesType,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      new MyApis.CommunicationresourcesApi()
        .GetPageContentByConditions(searchInfo)
        .then(r => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // eslint-disable-next-line no-unused-vars
    rowclick(row, column, e) {
      // 给分发事件
      this.dispatch("ZjEmergencyOneMap", "poiselected", row.ResourcesId);
      this.dispatch("ZjEmergencyOperations", "poiselected", row.ResourcesId);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    onCommunicationResourcesTypeSelectChange(val) {
      this.CommunicationResourcesType = val;
      this.search();
    }
  },
  watch: {
    center: function() {
      this.search();
    },
    searchText: function() {
      this.search();
    }
  }
};
</script>